import { Door, DoorBatteryWarningLevel, DoorType, Location } from 'graphql/generated/graphqlTypes';
import { getLockGroupsThatLockBelongTo, getLockStatus, isOfficeMode } from 'utils/Lock/Lock';
import {
  FilterBatteryStatusState,
  FilterDeviceGroupsState,
  FilterDeviceTypeState,
  FilterOfficeModeState
} from './deviceFilterTypes';

type Params = {
  devices: Door[];
  lockGroups: Location[];
  filterDeviceGroups: FilterDeviceGroupsState;
  filterDeviceType: FilterDeviceTypeState;
  filterBatteryStatus: FilterBatteryStatusState;
  filterOfficeMode: FilterOfficeModeState;
};

export const filterDevices = ({
  devices,
  lockGroups,
  filterDeviceGroups,
  filterDeviceType,
  filterBatteryStatus,
  filterOfficeMode
}: Params) => {
  let data = devices;

  if (filterDeviceGroups !== null) {
    if (filterDeviceGroups === FilterDeviceGroupsState.Assigned)
      data = data.filter((lock) => getLockGroupsThatLockBelongTo(lockGroups, lock.id).length > 0);
    if (filterDeviceGroups === FilterDeviceGroupsState.NotAssigned)
      data = data.filter((lock) => getLockGroupsThatLockBelongTo(lockGroups, lock.id).length === 0);
  }

  if (Object.values(filterDeviceType).some(Boolean))
    data = data.filter(
      (lock) =>
        (filterDeviceType.cylinder && lock.type === DoorType.DomCylinder) ||
        (filterDeviceType.handle && lock.type === DoorType.DomHandle) ||
        (filterDeviceType.locker && lock.type === DoorType.DomLocker) ||
        (filterDeviceType.reader && lock.type === DoorType.DomReader) ||
        (filterDeviceType.controller && lock.type === DoorType.DomController) ||
        (filterDeviceType.swingHandle && lock.type === DoorType.Tanlock)
    );

  if (Object.values(filterBatteryStatus).some(Boolean))
    data = data.filter(
      (lock) =>
        (filterBatteryStatus.unknown && getLockStatus(lock).batteryStatus === DoorBatteryWarningLevel.BatteryUnknown) ||
        (filterBatteryStatus.empty && getLockStatus(lock).batteryStatus === DoorBatteryWarningLevel.BatteryEmpty) ||
        (filterBatteryStatus.critical &&
          getLockStatus(lock).batteryStatus === DoorBatteryWarningLevel.BatteryCritical) ||
        (filterBatteryStatus.low && getLockStatus(lock).batteryStatus === DoorBatteryWarningLevel.BatteryLow) ||
        (filterBatteryStatus.full && getLockStatus(lock).batteryStatus === DoorBatteryWarningLevel.BatteryDefault)
    );

  if (filterOfficeMode !== null) {
    if (filterOfficeMode === FilterOfficeModeState.HasOfficeMode) data = data.filter((lock) => isOfficeMode(lock));
    if (filterOfficeMode === FilterOfficeModeState.NoOfficeMode) data = data.filter((lock) => !isOfficeMode(lock));
  }

  return data;
};
